var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2.5 0 62.4 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #20ac87;\n      }\n\n      .cls-2 {\n        fill: #F39D40;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.1,56.4c-1.8,0-3.3-1.6-3.2-3.4,0-1.8,1.5-3.2,3.3-3.2,1.8,0,3.3,1.5,3.3,3.3,0,1.8-1.6,3.3-3.4,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.1,53.1c0,1.8-1.5,3.3-3.3,3.3-1.8,0-3.3-1.5-3.3-3.2,0-1.8,1.5-3.4,3.3-3.4,1.8,0,3.3,1.5,3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.3,13.1c0,1.9-1.4,3.3-3.3,3.3-1.8,0-3.3-1.4-3.3-3.2,0-1.8,1.4-3.3,3.3-3.4,1.8,0,3.3,1.4,3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.9,50.3c-1.8,0-3.3-1.5-3.2-3.4,0-1.8,1.6-3.3,3.4-3.2,1.8,0,3.2,1.6,3.2,3.3,0,1.9-1.5,3.3-3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.8,46.8c0-1.8,1.6-3.2,3.5-3.1,1.8,0,3.2,1.6,3.1,3.4,0,1.9-1.6,3.2-3.4,3.2-1.8,0-3.2-1.6-3.1-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.5,36.2c0,1.8-1.5,3.3-3.3,3.3-1.8,0-3.3-1.5-3.3-3.3,0-1.8,1.5-3.2,3.2-3.3,1.8,0,3.4,1.4,3.4,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.5,7c0,1.8-1.6,3.3-3.4,3.3-1.8,0-3.2-1.5-3.2-3.3s1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.2,9.8c1.9,0,3.3,1.5,3.2,3.4,0,1.8-1.5,3.2-3.3,3.2-1.9,0-3.3-1.5-3.3-3.3,0-1.9,1.5-3.3,3.4-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.5,23.9c0,1.8-1.6,3.3-3.4,3.2-1.8,0-3.3-1.5-3.2-3.4,0-1.8,1.6-3.3,3.4-3.3,1.8,0,3.3,1.6,3.3,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.9,3.6c1.9,0,3.3,1.6,3.3,3.4,0,1.8-1.6,3.3-3.4,3.2-1.8,0-3.2-1.6-3.2-3.3,0-1.8,1.5-3.3,3.4-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,32.9c1.9,0,3.3,1.5,3.3,3.3,0,1.8-1.6,3.3-3.4,3.2-1.8,0-3.3-1.6-3.2-3.4,0-1.8,1.5-3.2,3.3-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.9,27.1c-1.8,0-3.3-1.5-3.3-3.4,0-1.8,1.5-3.2,3.3-3.2,1.8,0,3.3,1.5,3.3,3.2,0,1.9-1.5,3.4-3.3,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.4,53.7c0,1.5-1.4,2.8-2.9,2.7-1.5,0-2.7-1.3-2.7-2.9,0-1.5,1.3-2.8,2.9-2.7,1.6,0,2.8,1.4,2.7,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.5,16.3c-1.5,0-2.8-1.2-2.8-2.8,0-1.5,1.2-2.7,2.7-2.8,1.6,0,2.8,1.2,2.8,2.8,0,1.6-1.2,2.8-2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.3,20.5c0,1.6-1.2,2.8-2.8,2.8-1.6,0-2.8-1.2-2.8-2.8,0-1.6,1.3-2.8,2.8-2.8,1.6,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.3,46.5c0,1.6-1.2,2.8-2.8,2.8-1.5,0-2.7-1.2-2.8-2.7,0-1.6,1.2-2.8,2.8-2.9,1.6,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.5,43.7c1.6,0,2.8,1.2,2.8,2.8,0,1.5-1.2,2.7-2.7,2.8-1.6,0-2.8-1.2-2.9-2.8,0-1.6,1.2-2.8,2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.2,53.6c0,1.6-1.3,2.8-2.9,2.7-1.5,0-2.7-1.3-2.7-2.8,0-1.6,1.3-2.8,2.8-2.8,1.5,0,2.8,1.3,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.5,17.7c1.6,0,2.8,1.2,2.8,2.8,0,1.5-1.3,2.8-2.8,2.8-1.5,0-2.7-1.2-2.8-2.7,0-1.6,1.2-2.8,2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.3,39.5c0,1.6-1.2,2.8-2.8,2.8-1.6,0-2.8-1.2-2.8-2.7,0-1.6,1.2-2.8,2.8-2.8,1.6,0,2.8,1.2,2.8,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.8,30c0,1.6-1.2,2.8-2.8,2.8-1.6,0-2.8-1.3-2.8-2.8,0-1.5,1.2-2.7,2.8-2.7,1.6,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.5,42.3c-1.6,0-2.8-1.3-2.8-2.8,0-1.5,1.3-2.7,2.8-2.7,1.6,0,2.8,1.2,2.8,2.8,0,1.6-1.3,2.8-2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60,30c0,1.6-1.3,2.8-2.9,2.8-1.6,0-2.8-1.3-2.7-2.9,0-1.5,1.3-2.7,2.8-2.7,1.6,0,2.8,1.3,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,32.8c-1.6,0-2.8-1.2-2.8-2.8,0-1.5,1.2-2.7,2.7-2.8,1.6,0,2.9,1.2,2.9,2.7,0,1.6-1.2,2.8-2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.8,43.6c0-1.5,1.2-2.7,2.7-2.7,1.6,0,2.8,1.2,2.8,2.8,0,1.5-1.3,2.8-2.8,2.8-1.6,0-2.8-1.3-2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.6,19.2c-1.6,0-2.8-1.2-2.8-2.8,0-1.6,1.3-2.8,2.9-2.8,1.5,0,2.8,1.3,2.7,2.9,0,1.5-1.3,2.7-2.8,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.7,13.6c0-1.5,1.2-2.8,2.8-2.8,1.5,0,2.8,1.2,2.8,2.8,0,1.6-1.2,2.8-2.7,2.8-1.6,0-2.8-1.2-2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.6,9.2c-1.6,0-2.8-1.2-2.8-2.8,0-1.6,1.3-2.8,2.8-2.8,1.5,0,2.8,1.3,2.7,2.9,0,1.5-1.3,2.7-2.8,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,54.4c1.6,0,2.8,1.2,2.8,2.8,0,1.6-1.2,2.8-2.8,2.8-1.5,0-2.7-1.2-2.7-2.7,0-1.6,1.2-2.8,2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.2,43.6c0,1.6-1.2,2.8-2.8,2.8-1.6,0-2.8-1.3-2.8-2.8,0-1.5,1.2-2.7,2.8-2.7,1.6,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.4,13.6c1.5,0,2.7,1.2,2.8,2.7,0,1.6-1.2,2.8-2.7,2.9-1.6,0-2.8-1.2-2.8-2.8,0-1.5,1.2-2.8,2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.8,49.1c0,1.6-1.3,2.8-2.9,2.7-1.6,0-2.8-1.3-2.7-2.9,0-1.5,1.3-2.7,2.8-2.7,1.5,0,2.8,1.3,2.8,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.2,6.4c0,1.5-1.2,2.7-2.7,2.8-1.6,0-2.8-1.2-2.9-2.7,0-1.5,1.3-2.9,2.8-2.8,1.6,0,2.8,1.3,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.8,32.8C1.2,32.8,0,31.6,0,30c0-1.6,1.2-2.8,2.8-2.8,1.5,0,2.7,1.2,2.8,2.7,0,1.6-1.2,2.8-2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,13.8c-1.5,0-2.7-1.2-2.8-2.7,0-1.6,1.2-2.8,2.7-2.8,1.6,0,2.8,1.2,2.8,2.8,0,1.6-1.2,2.8-2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,0c1.6,0,2.8,1.2,2.8,2.8,0,1.5-1.2,2.7-2.7,2.8-1.6,0-2.9-1.2-2.8-2.9C27.2,1.2,28.5,0,30,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.7,31.9c-1.1,0-2-.9-2-1.9,0-1,.9-1.9,1.9-1.9,1,0,1.9.9,1.9,1.9,0,1-.8,1.9-1.9,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.3,30c0,1-.9,1.9-1.9,1.9-1,0-1.9-.9-1.9-2,0-1,.9-1.9,2-1.8,1,0,1.9.9,1.8,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.7,35.9c0-1,1-1.9,2-1.8,1.1,0,1.9,1,1.8,2.1,0,1-1,1.8-2,1.8-1,0-1.8-1-1.8-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.4,22.1c1.1,0,1.9,1,1.9,2,0,1-1,1.9-2,1.8-1,0-1.8-.9-1.8-2,0-1,.9-1.9,1.9-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.4,34.1c1,0,1.9.9,1.9,1.9,0,1-.9,1.9-1.9,1.9-1.1,0-1.9-.9-1.9-1.9,0-1,.9-1.9,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.5,24c0,1-.8,1.9-1.9,1.9-1,0-2-.9-1.9-2,0-1,.9-1.9,1.9-1.9,1,0,1.9.9,1.9,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.1,27.1c0,1-.9,1.8-1.9,1.8-1.1,0-2-.9-1.9-2,0-1,.8-1.8,1.8-1.8,1.1,0,2,.9,1.9,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.2,40.9c-1.1,0-1.9-.9-1.9-2,0-1,.9-1.8,1.9-1.8,1.1,0,1.9.9,1.9,2,0,1-.9,1.9-1.9,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.8,25.1c1.1,0,1.9.8,1.9,1.9,0,1.1-.8,1.9-1.9,1.9-1.1,0-2-.9-1.9-2,0-1,.9-1.8,1.9-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30,28.1c1,0,1.9.9,1.9,2,0,1-1,1.9-1.9,1.8-1,0-1.9-.9-1.9-1.9,0-1,.9-1.9,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.9,34.9c-1.1,0-2-.9-2-1.9,0-1,.9-1.8,1.9-1.8,1.1,0,1.9.8,1.9,1.9,0,1.1-.8,1.9-1.8,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.1,33c0,1-.9,1.8-1.8,1.9-1.1,0-2-.8-1.9-1.9,0-1,.8-1.8,1.8-1.9,1.1,0,2,.9,2,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.9,24.1c0,1-.9,1.9-1.9,1.9-1,0-1.9-.9-1.9-1.9,0-1,1-1.9,2-1.9,1,0,1.8,1,1.8,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30,43.9c-1,0-1.9-.9-1.9-1.9,0-1,.9-2,2-1.9,1,0,1.9.9,1.9,1.9,0,1-.9,1.9-1.9,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.9,36c0,1-.8,1.9-1.9,1.9-1,0-2-.9-2-1.9,0-1,.9-1.9,1.9-1.9,1,0,1.9.9,1.9,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.9,18.1c0,1-.9,1.9-1.9,1.9-1,0-1.9-.9-1.9-1.9,0-1,.9-1.9,2-1.9,1,0,1.9.9,1.8,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.9,19.1c1.1,0,1.9.9,1.8,2,0,1-.9,1.8-1.9,1.7-1.1,0-1.9-.9-1.9-2,0-1,1-1.8,2-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.9,37.1c1,0,1.9.9,1.8,1.9,0,1.1-.9,1.9-1.9,1.8-1.1,0-1.9-.9-1.9-1.9,0-1,.9-1.9,1.9-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.1,22.9c-1,0-1.9-.9-1.8-1.9,0-1.1.9-1.9,1.9-1.8,1.1,0,1.9.9,1.9,1.9,0,1-.9,1.9-1.9,1.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/LogoMain.feb257b488a6bb5e1f3aecf92211078d.svg";
export { ForwardRef as ReactComponent };